/**
 * Logo Carousel
 *
 * Paginated slider for .logo-carousel.is-carousel. Advances a page at a time
 * (page = however many logos are currently visible, computed from item width so
 * it stays correct across breakpoints). Supports prev/next, dots, and optional
 * autoplay (data-autoplay / data-speed). Pauses autoplay on hover.
 */
( function () {
	'use strict';

	function initCarousel( root ) {
		var viewport = root.querySelector( '.logo-carousel-viewport' );
		var track    = root.querySelector( '.logo-carousel-track' );
		var items    = root.querySelectorAll( '.logo-carousel-item' );
		var prevBtn  = root.querySelector( '.logo-carousel-prev' );
		var nextBtn  = root.querySelector( '.logo-carousel-next' );
		var dotsWrap = root.querySelector( '.logo-carousel-dots' );

		if ( ! track || items.length === 0 ) {
			return;
		}

		var page = 0;

		function perPage() {
			var itemWidth = items[0].offsetWidth || 1;
			var vpWidth   = viewport.clientWidth || 1;
			return Math.max( 1, Math.round( vpWidth / itemWidth ) );
		}

		function pageCount() {
			return Math.max( 1, Math.ceil( items.length / perPage() ) );
		}

		function buildDots() {
			if ( ! dotsWrap ) {
				return;
			}
			dotsWrap.innerHTML = '';
			var total = pageCount();
			for ( var i = 0; i < total; i++ ) {
				var dot = document.createElement( 'button' );
				dot.type = 'button';
				dot.className = 'dot' + ( i === page ? ' active' : '' );
				dot.setAttribute( 'aria-label', 'Go to logo group ' + ( i + 1 ) );
				( function ( index ) {
					dot.addEventListener( 'click', function () {
						goTo( index );
					} );
				} )( i );
				dotsWrap.appendChild( dot );
			}
		}

		function update() {
			var per = perPage();
			var total = pageCount();
			if ( page > total - 1 ) {
				page = total - 1;
			}
			// Shift by whole pages; clamp so the last page aligns to the end.
			var maxOffset = Math.max( 0, items.length - per );
			var offsetItems = Math.min( page * per, maxOffset );
			track.style.transform = 'translateX(-' + ( offsetItems * items[0].offsetWidth ) + 'px)';

			if ( dotsWrap ) {
				var dots = dotsWrap.querySelectorAll( '.dot' );
				for ( var i = 0; i < dots.length; i++ ) {
					dots[ i ].classList.toggle( 'active', i === page );
				}
			}
		}

		function goTo( index ) {
			var total = pageCount();
			page = ( index + total ) % total;
			update();
		}

		function next() {
			goTo( page + 1 );
		}

		function prev() {
			goTo( page - 1 );
		}

		if ( nextBtn ) {
			nextBtn.addEventListener( 'click', next );
		}
		if ( prevBtn ) {
			prevBtn.addEventListener( 'click', prev );
		}

		// Autoplay.
		var autoplay = root.getAttribute( 'data-autoplay' ) === '1';
		var speed    = parseInt( root.getAttribute( 'data-speed' ), 10 ) || 3000;
		var timer    = null;

		function start() {
			if ( autoplay && ! timer && pageCount() > 1 ) {
				timer = window.setInterval( next, speed );
			}
		}
		function stop() {
			if ( timer ) {
				window.clearInterval( timer );
				timer = null;
			}
		}

		root.addEventListener( 'mouseenter', stop );
		root.addEventListener( 'mouseleave', start );

		// Rebuild on resize (per-page count can change across breakpoints).
		var resizeTimer = null;
		window.addEventListener( 'resize', function () {
			window.clearTimeout( resizeTimer );
			resizeTimer = window.setTimeout( function () {
				buildDots();
				update();
			}, 150 );
		} );

		buildDots();
		update();
		start();
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		var carousels = document.querySelectorAll( '.logo-carousel.is-carousel' );
		for ( var i = 0; i < carousels.length; i++ ) {
			initCarousel( carousels[ i ] );
		}
	} );
} )();
